import { render, staticRenderFns } from "./FAQV2.vue?vue&type=template&id=23b59383"
import script from "./FAQV2.vue?vue&type=script&lang=js"
export * from "./FAQV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports